import * as React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';

interface WellProps {
  title?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon?: React.FC<any>;
  children: React.ReactNode;
}

const Well = ({ title, Icon, children }: WellProps): JSX.Element => {
  const hasTitle = Boolean(title);

  return (
    <Card
      className="relative rounded-sm shadow-md"
      data-testid="well-component"
    >
      {hasTitle && (
        <CardHeader className="flex flex-row items-center gap-2 space-y-0 p-2 pb-0">
          {Icon && <Icon className="inline h-5 w-5 text-blue-500" />}
          <CardTitle className="text-sm font-medium text-gray-900 title-font">
            {title}
          </CardTitle>
        </CardHeader>
      )}
      <CardContent className="p-2 text-xs shadow-none">{children}</CardContent>
    </Card>
  );
};

export default Well;
